module.exports = __webpack_public_path__ + "media/step5_animation.e349431c.webm";